import { DOCUMENT_EDITOR_CONFIG } from "slices/writing/documents/documentsSlice";

const UNLINKED_ENTITY_TYPE = "UNLINKED";

export const resolvePresenceTarget = (isUnlinked, metadata, unlinkedDocumentId) => {
  const entityType = isUnlinked ? UNLINKED_ENTITY_TYPE : metadata.entityType;
  const entityId = isUnlinked ? metadata.unlinkedEntityId : metadata.entityId;
  const documentId = isUnlinked ? unlinkedDocumentId : metadata.documentId;
  const config = DOCUMENT_EDITOR_CONFIG[entityType];

  return config && documentId ? { config, documentId, entityId, entityType } : null;
};

export const presenceTargetKey = (target) =>
  target ? `${target.entityType}:${target.entityId}:${target.documentId}` : null;

export const presenceEndpoint = (config, documentId) =>
  `${config.endpoint}/${documentId}/editing-presence`;

export const presenceParams = (isUnlinked, config, entityId, workspaceId) =>
  isUnlinked
    ? { [config.paramKey]: entityId }
    : { [config.paramKey]: entityId, workspaceId };
